import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useWhatsAppContact } from "@/components/whatsapp/use-whatsapp-contact";

export function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  // Handy/Tablet: Ist der WhatsApp-Button da, rückt der Hoch-Button links daneben.
  const whatsapp = useWhatsAppContact();

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 400);
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Zum Seitenanfang"
      style={{ bottom: "max(1.5rem, calc(env(safe-area-inset-bottom) + 0.75rem))" }}
      className={`fixed ${whatsapp.visible ? "right-[5.25rem]" : "right-6"} z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-brand-button shadow-lg transition-all duration-300 ease-out hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-button focus-visible:ring-offset-2 lg:hidden ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <ArrowUp className="h-5 w-5" strokeWidth={2.5} />
    </button>
  );
}
